var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full preferencesPage"},[_c('preference-swiper',{attrs:{"preferences":_vm.preferences}}),_c('navbar',{on:{"applySearch":_vm.applySearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }